import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SvgXIcon from '../svg/XIcon';
import { clearUiMsg } from '../../redux/actions/uiActions';
import { FormattedMessage } from 'react-intl';

/**
 * Alert message component for ui alerts
 * @param {string} props.message - the message object with all of the information to be displayed
 * @param {string} props.message.message - the message to be displayed
 * @param {string} props.message.messageType - the type of message to be displayed
 * @param {string} props.message.id - the id of the message being displayed. This is used for closing messages
 * @param {string} props.message.error - The specific error to be displayed when an error occurs
 */

export const messageTypes = {
  success: 'success',
  danger: 'danger',
  warning: 'warning',
};

export function UnconnectedAlertMessage(props) {
  const { message, messageType, id, error } = props.message;
  const [displayStyle, setDisplayStyle] = useState(
    'ui-alert-message__message--visible'
  );

  useEffect(() => {
    if (messageType === 'success') {
      setTimeout(() => {
        closeAlert();
      }, 7000);
    }
  }, []); //eslint-disable-line

  function closeAlert() {
    setDisplayStyle('ui-alert-message__message--expanded');
    setTimeout(() => {
      setDisplayStyle('');
    }, 400);
    setTimeout(() => {
      props.dispatch(clearUiMsg(id));
    }, 1000);
  }

  function displayError() {
    if (error) {
      return (
        <div
          className="ui-alert-message__error-text"
          data-test="error-container">
          <p className="no-margin">
            <FormattedMessage
              id="alertMessage.errorReturnedText"
              defaultMessage="The error returned was:"
              description="The error returned from the server as a result of the user's action."
            />
          </p>
          <div
            className="no-margin sentence-case text-italic"
            data-test="error">
            {error}
          </div>
        </div>
      );
    }
  }

  let messageStyle = '';
  switch (messageType) {
    case messageTypes.success:
      messageStyle = 'alert_message--success ';
      break;
    case messageTypes.danger:
      messageStyle = 'alert_message--danger ';
      break;
    case messageTypes.warning:
      messageStyle = 'alert_message--warning ';
      break;

    default:
      break;
  }

  return (
    <div
      data-test="alert-message"
      className={`ui-alert-message__message ${messageStyle} align-top ${displayStyle}`}>
      <div className="ui-alert-message__message-text-container">
        <div
          className="ui-alert-message__message-text text-medium text-bold"
          data-test="message">
          {message}
        </div>
        {displayError()}
      </div>
      <div className="text-large close-window-icon-button">
        <SvgXIcon onClick={closeAlert} data-test="close-icon" />
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    message: state.ui.uiMessages[ownProps.messageId],
  };
};

export default connect(mapStateToProps)(UnconnectedAlertMessage);
